<div
    class="modal fade"
    id="app-modal-share-file"
    tabindex="-1"
    role="dialog"
    aria-labelledby="modelTitleId"
    aria-hidden="true"
    >
    <div
        class="modal-dialog modal-dialog-centered"
        role="document"
        >
        <div
            class="modal-content rounded"
            [ngClass]="{'bg-dark': isDarkmode}"
            >
            <app-header-title
                closeButton="closeButtonShareFile"
                title="shared_dialog.title_share"
                modalId="app-modal-share-file"
                >
            </app-header-title>
            <div
                class="modal-body"
                [ngClass]="{'bg-dark white-text': isDarkmode}"
                >
                <div class="container">
                    <div class="row">
                        <div class="col-12 col-sm-2 text-center mt-1">
                            <i
                                class="fa fa-file-excel-o fa-2x"
                                aria-hidden="true"
                                >
                            </i>
                        </div>
                        <div class="col-12 col-sm-10">
                            <p class="no-space tiny">
                                {{fileName+"."+extension}}
                            </p>
                        </div>
                    </div>
                    <div class="row mt-2">
                        <div class="col-12 col-sm-6">
                            <p class="text-end text-right ">{{ "shared_dialog.add_format"| translate }}</p>
                        </div>
                        <div class="col-12 col-sm-6">
                            <app-segmented-selector
                                [items]="extensions"
                                [currentItem]="extension"
                                (emitter)="setExtension($event)"
                                >
                            </app-segmented-selector>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button
                    id="btn-close-modal"
                    type="button"
                    class="btn btn-secondary semi-rounded"
                    data-bs-dismiss="modal"
                    >{{ "buttons.button_close"| translate }}
                </button>
                <button
                    (click)="export()"
                    type="button"
                    class="btn clear-outline bg-main-purple white-text"
                    >{{ "buttons.button_save"| translate }}
                </button>
            </div>
        </div>
    </div>
</div>
